import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import Loader from 'components/Loader/Loader';
import App from './App.tsx';

import './i18n';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<Loader isLoading={true} />}><App/></Suspense>
  </StrictMode>,
);
